import { IRawCompanySettingsGeneral } from "@propely/propely-typings";
import { Role } from "@src/to-be-removed/LocalData/User/Role";
import { settings } from "firebase/analytics";
import { t } from "i18next";

export const getSingularRoleTitle = (roleID: number, settings: IRawCompanySettingsGeneral | undefined): string => {
  const customTitle = settings?.roleTitles?.[roleID]?.singular;
  if (customTitle) return customTitle;

  if (settings?.roleTitles?.[roleID]?.id === "manager") {
    return t("main.manager");
  } else if (settings?.roleTitles?.[roleID]?.id === "landlord") {
    return t("main.landlord");
  } else if (settings?.roleTitles?.[roleID]?.id === "resident") {
    return t("main.resident");
  } else if (settings?.roleTitles?.[roleID]?.id === "tenant") {
    return t("main.tenant");
  }

  let singularTitle = t("main.tenant");
  if (roleID === 0) {
    singularTitle = t("main.tenant");
  } else if (roleID === 1) {
    singularTitle = t("main.landlord");
  } else if (roleID === 2) {
    singularTitle = t("main.contractor");
  }

  return singularTitle;
};

export const getPluralRoleTitle = (roleID: number, settings: IRawCompanySettingsGeneral | undefined): string => {
  const customTitle = settings?.roleTitles?.[roleID]?.plural;
  if (customTitle) return customTitle;

  if (settings?.roleTitles?.[roleID]?.id === "manager") {
    return t("main.managers");
  } else if (settings?.roleTitles?.[roleID]?.id === "landlord") {
    return t("main.landlords");
  } else if (settings?.roleTitles?.[roleID]?.id === "resident") {
    return t("main.residents");
  } else if (settings?.roleTitles?.[roleID]?.id === "tenant") {
    return t("main.tenants");
  }

  let pluralTitle = t("main.tenants");
  if (roleID === 0) {
    pluralTitle = t("main.tenants");
  } else if (roleID === 1) {
    pluralTitle = t("main.landlords");
  } else if (roleID === 2) {
    pluralTitle = t("main.contractors");
  }

  return pluralTitle;
};

export const getRoleTitleForCount = (roleID: number, count: number, settings: IRawCompanySettingsGeneral | undefined) => {
  if (count === 1) return getSingularRoleTitle(roleID, settings);
  return getPluralRoleTitle(roleID, settings);
};

export const getSingularTenantUnitTitle = (settings: IRawCompanySettingsGeneral | undefined) => {
  return getSingularRoleTitle(Role.RENTER.id, undefined) + t("main.unitSuffix");
};

export const getPluralTenantUnitTitle = (settings: IRawCompanySettingsGeneral | undefined) => {
  return getSingularRoleTitle(Role.RENTER.id, undefined) + t("main.unitsSuffix");
};

